/**
 * @generated SignedSource<<a3c6cc9a60e0930d258ff0eca06a2781>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmailTypeEnum = "HTML" | "PLAIN";
export type EmailSenderInput = {
  body?: string | null | undefined;
  cc?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  from?: string | null | undefined;
  replyTo?: string | null | undefined;
  subject?: string | null | undefined;
  to?: ReadonlyArray<string | null | undefined> | null | undefined;
  type?: EmailTypeEnum | null | undefined;
};
export type EmailSender_Mutation$variables = {
  input: EmailSenderInput;
};
export type EmailSender_Mutation$data = {
  readonly emailSender: {
    readonly message: string | null | undefined;
    readonly origin: string | null | undefined;
    readonly sent: boolean | null | undefined;
    readonly to: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
};
export type EmailSender_Mutation = {
  response: EmailSender_Mutation$data;
  variables: EmailSender_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailSenderPayload",
    "kind": "LinkedField",
    "name": "emailSender",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "origin",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "to",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailSender_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailSender_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "654983af85d96e6e45d5a5fc1e96b7a4",
    "id": null,
    "metadata": {},
    "name": "EmailSender_Mutation",
    "operationKind": "mutation",
    "text": "mutation EmailSender_Mutation(\n  $input: EmailSenderInput!\n) {\n  emailSender(input: $input) {\n    message\n    origin\n    sent\n    to\n  }\n}\n"
  }
};
})();

(node as any).hash = "9277e2c14893aed9eb3ab303b7f695da";

export default node;
